/* Custom javascript */


/* Convert h1 BBcodes */
let h1s = document.querySelectorAll('h1');
bbcode(h1s);

/* Convert h2 BBcodes */
let h2s = document.querySelectorAll('h2');
bbcode(h2s);

function bbcode(nodelist) {
  for (i = 0; i < nodelist.length; ++i) {
    let html = nodelist[i].innerHTML;
    html = html.replace('[i]', '<i>');
    html = html.replace('[/i]', '</i>');
    html = html.replace('[br]', '<br>');
    nodelist[i].innerHTML = html;
  }
}

// for (i = 0; i < h2s.length; ++i) {
//   let html = h2s[i].innerHTML;
//   html = html.replace('[i]', '<i>');
//   html = html.replace('[/i]', '</i>');
//   console.log(html);
//   h2s[i].innerHTML = html;
// }

/* Add transparent header class to body */
// get sticky-header element
const stickyHeader = document.getElementsByTagName('sticky-header');

if( stickyHeader[0].classList.contains('header-transparent') ) {
  console.log('transparent header');
  document.body.classList.add("transparent-header");
}


/* Launch external links in a new tab */
let links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}


/* Move the low stock notice higher in the page */
document.addEventListener('DOMContentLoaded', function () {
    // Select the product inventory ul and product form div
    var productInventory = document.querySelector('.product__inventory');
    var productForm = document.querySelector('.product-form');

    // Ensure both elements exist before moving
    if (productInventory && productForm) {
        // Move the product inventory before the product form
        productForm.parentNode.insertBefore(productInventory, productForm);
    }
});


/* Product Page - Hide Company reviews block if exact product reviews appear */
(function waitUntilReviewAvatarAppears() {
  const maxWaitTime = 15000;
  const intervalTime = 250;
  let waited = 0;

  const check = () => {
    const avatar = document.querySelector(".R-AvatarThumbnail__inner");
    if (avatar) {
      const carousels = document.querySelectorAll(".CarouselWidget--default");
      if (carousels.length > 0) {
        carousels.forEach(el => el.style.display = "none");
        console.log("✅ Hiding carousel — reviews avatar found.");
        return; // ✅ Done
      }
    }

    waited += intervalTime;
    if (waited < maxWaitTime) {
      setTimeout(check, intervalTime);
    }
  };

  // Delay the first check slightly to allow REVIEWS.io to begin loading
  setTimeout(check, 500);
})();
